<template>
  <div id="main">
    <div id="manu">
      <navigation />
    </div>
    <div id="contentBox">
      <div class="registervideoContainer"></div>
      <div class="w">
        <!-- 管理菜单导航 -->
        <div class="management-menu">
          <el-button
            :class="{ 'active-menu': currentMenu === 'invite' }"
            @click="currentMenu = 'invite'"
          >邀请码管理</el-button>
          <el-button
            :class="{ 'active-menu': currentMenu === 'account' }"
            @click="currentMenu = 'account'"
          >账号管理</el-button>
          <el-button
            :class="{ 'active-menu': currentMenu === 'ban' }"
            @click="currentMenu = 'ban'"
          >封禁管理</el-button>
          <el-button
            :class="{ 'active-menu': currentMenu === 'feedback' }"
            @click="currentMenu = 'feedback'"
          >反馈管理</el-button>
          <el-button
            :class="{ 'active-menu': currentMenu === 'comment' }"
            @click="currentMenu = 'comment'"
          >评论管理</el-button>
          <el-button
            :class="{ 'active-menu': currentMenu === 'location' }"
            @click="currentMenu = 'location'"
          >位置显示管理</el-button>
          <el-button
            :class="{ 'active-menu': currentMenu === 'order' }"
            @click="currentMenu = 'order'"
          >订单管理</el-button>
        </div>

        <!-- 邀请码管理内容 -->
        <div class="generate-container" v-if="currentMenu === 'invite'" :key="currentMenu">
          <h1>邀请码管理</h1>
          <!-- 生成邀请码区域 -->
          <div class="generate-section">
            <h2>生成新邀请码</h2>
            <div class="generate-form">
              <div class="form-item">
                <label>有效天数（默认30天）：</label>
                <el-input-number v-model="validDays" :min="1" placeholder="请输入有效天数" />
              </div>
              <div class="form-item">
                <label>备注（测试/正式）：</label>
                <el-input v-model="remark" placeholder="请输入备注，如测试或正式" />
              </div>
              <el-button type="primary" @click="generateInviteCode" :loading="loading">生成邀请码</el-button>
              <div v-if="loading" class="loading">生成中...</div>
              <div v-else-if="error" class="error">{{ error }}</div>
              <div v-else-if="inviteCode" class="success">
                <p>生成的邀请码：{{ inviteCode }}</p>
                <el-button @click="copyInviteCode(inviteCode)">复制</el-button>
              </div>
            </div>
          </div>
          <!-- 邀请码列表区域 -->
          <div class="invite-list-section">
            <h2>邀请码列表</h2>
            <div v-if="listLoading" class="loading">加载中...</div>
            <div v-else-if="listError" class="error">{{ listError }}</div>
            <div v-else-if="inviteList.length === 0" class="no-data">暂无邀请码数据</div>
            <el-table v-else :data="inviteList" style="width: 100%" class="invite-table">
              <el-table-column prop="code" label="邀请码" />
              <el-table-column label="状态">
                <template #default="{ row }">
                  {{ row.is_disabled ? '已禁用' : row.is_used ? '已使用' : row.is_expired ? '已过期' : '未使用' }}
                </template>
              </el-table-column>
              <el-table-column prop="created_by_username" label="创建者">
                <template #default="{ row }">
                  {{ row.created_by_username || '-' }}
                </template>
              </el-table-column>
              <el-table-column label="创建时间">
                <template #default="{ row }">
                  {{ formatDate(row.created_at) }}
                </template>
              </el-table-column>
              <el-table-column label="有效期至">
                <template #default="{ row }">
                  {{ row.expires_at ? formatDate(row.expires_at) : '永久有效' }}
                </template>
              </el-table-column>
              <el-table-column label="使用时间">
                <template #default="{ row }">
                  {{ row.used_at ? formatDate(row.used_at) : '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="username" label="注册用户">
                <template #default="{ row }">
                  {{ row.username || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="register_ip" label="注册IP">
                <template #default="{ row }">
                  {{ row.register_ip || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="device_name" label="设备名称">
                <template #default="{ row }">
                  {{ row.device_name || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注">
                <template #default="{ row }">
                  {{ row.remark || '-' }}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template #default="{ row }">
                  <el-button
                    type="primary"
                    size="small"
                    @click="showEditModal(row)"
                    :disabled="!!(row.is_used || row.is_expired || row.is_disabled)"
                  >编辑</el-button>
                  <el-button
                    type="warning"
                    size="small"
                    @click="disableInviteCode(row)"
                    :disabled="!!(row.is_used || row.is_expired || row.is_disabled)"
                  >禁用</el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteInviteCode(row)"
                    :disabled="!!(row.is_used || row.is_expired || row.is_disabled)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 账号管理内容 -->
        <div class="generate-container" v-if="currentMenu === 'account'" :key="currentMenu">
          <h1>账号管理</h1>
          <!-- 新增管理员区域 -->
          <div class="generate-section">
            <h2>新增管理员</h2>
            <el-form
              ref="createAdminFormRef"
              :model="adminForm"
              :rules="adminRules"
              label-width="120px"
              class="generate-form"
            >
              <el-form-item label="管理员用户名" prop="username">
                <el-input v-model="adminForm.username" placeholder="请输入管理员用户名" />
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input
                  v-model="adminForm.password"
                  type="password"
                  placeholder="请输入密码"
                  show-password
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="createAdmin" :loading="createAdminLoading">
                  创建管理员
                </el-button>
              </el-form-item>
            </el-form>
            <div v-if="createAdminLoading" class="loading">创建中...</div>
            <div v-else-if="createAdminError" class="error">{{ createAdminError }}</div>
            <div v-else-if="createAdminSuccess" class="success">
              管理员 {{ adminForm.username }} 创建成功
            </div>
          </div>
          <!-- 用户列表区域 -->
          <div class="invite-list-section">
            <h2>用户列表</h2>
            <el-input
              v-model="userSearch"
              placeholder="搜索用户名或邮箱"
              style="width: 300px; margin-bottom: 20px;"
              @input="handleUserSearch"
            />
            <div v-if="listLoading" class="loading">加载中...</div>
            <div v-else-if="listError" class="error">{{ listError }}</div>
            <div v-else-if="userList.length === 0" class="no-data">暂无用户数据</div>
            <el-table v-else :data="filteredUserList" style="width: 100%" class="invite-table">
              <el-table-column prop="id" label="ID" />
              <el-table-column prop="username" label="用户名" />
              <el-table-column prop="email" label="邮箱" />
              <el-table-column prop="version" label="版本">
                <template #default="{ row }">
                  <el-select
                    v-model="row.version"
                    @change="debouncedUpdateVersion(row, row.versionPeriod)"
                    placeholder="选择版本"
                    style="width: 120px; margin-right: 10px;"
                  >
                    <el-option label="高级版" value="basic" />
                    <el-option label="订阅版" value="advanced" />
                    <el-option label="年费版" value="enterprise" />
                  </el-select>
                  <el-select
                    v-model="row.versionPeriod"
                    @change="debouncedUpdateVersion(row, row.versionPeriod)"
                    placeholder="选择有效期"
                    style="width: 100px;"
                  >
                    <el-option label="周" value="week" />
                    <el-option label="月" value="month" />
                    <el-option label="季" value="quarter" />
                    <el-option label="年" value="year" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="版本有效期">
                <template #default="{ row }">
                  {{ row.version_expiry ? formatDate(row.version_expiry) : '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="subscription_status" label="订阅状态">
                <template #default="{ row }">
                  <el-switch
                    v-model="row.subscription_status"
                    @change="debouncedUpdateSubscription(row)"
                    :disabled="updatingSubscription[row.id]"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="is_banned" label="封禁状态">
                <template #default="{ row }">
                  <el-button
                    :type="row.is_banned ? 'success' : 'danger'"
                    size="small"
                    @click="toggleUserBan(row)"
                  >
                    {{ row.is_banned ? '解封' : '封禁' }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template #default="{ row }">
                  <el-button
                    type="primary"
                    size="small"
                    @click="showEditUserModal(row)"
                  >编辑</el-button>
                  <el-button
                    type="warning"
                    size="small"
                    @click="showResetPwdModal(row, 'user')"
                  >重置密码</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 管理员列表区域 -->
          <div class="invite-list-section">
            <h2>管理员列表</h2>
            <div v-if="listLoading" class="loading">加载中...</div>
            <div v-else-if="listError" class="error">{{ listError }}</div>
            <div v-else-if="adminList.length === 0" class="no-data">暂无管理员数据</div>
            <el-table v-else :data="adminList" style="width: 100%" class="invite-table">
              <el-table-column prop="id" label="ID" />
              <el-table-column prop="username" label="用户名" />
              <el-table-column label="操作">
                <template #default="{ row }">
                  <el-button
                    type="warning"
                    size="small"
                    @click="showResetPwdModal(row, 'admin')"
                  >重置密码</el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteAdmin(row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 其他管理模块占位 -->
        <div class="management-placeholder" v-if="currentMenu === 'ban'" :key="currentMenu">
          <h1>封禁管理</h1>
          <p>封禁管理功能正在开发中...</p>
        </div>
        <div class="management-placeholder" v-if="currentMenu === 'feedback'" :key="currentMenu">
          <h1>反馈管理</h1>
          <p>反馈管理功能正在开发中...</p>
        </div>
        <div class="management-placeholder" v-if="currentMenu === 'comment'" :key="currentMenu">
          <h1>评论管理</h1>
          <p>评论管理功能正在开发中...</p>
        </div>
        <div class="management-placeholder" v-if="currentMenu === 'location'" :key="currentMenu">
          <h1>位置显示管理</h1>
          <p>位置显示管理功能正在开发中...</p>
        </div>
        <div class="management-placeholder" v-if="currentMenu === 'order'" :key="currentMenu">
          <h1>订单管理</h1>
          <div class="order-management">
            <div v-if="orderLoading" class="loading">加载中...</div>
            <div v-else-if="orderError" class="error">{{ orderError }}</div>
            <div v-else-if="orderList.length === 0" class="no-data">暂无订单数据</div>
            <el-table v-else :data="orderList" style="width: 100%" class="order-table">
              <el-table-column prop="order_no" label="订单编号" />
              <el-table-column prop="username" label="用户名" />
              <el-table-column prop="plan_name" label="套餐名称" />
              <el-table-column label="金额">
                <template #default="{ row }">￥{{ row.amount }}</template>
              </el-table-column>
              <el-table-column prop="status" label="状态" />
              <el-table-column label="创建时间">
                <template #default="{ row }">
                  {{ formatDate(row.created_at) }}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template #default="{ row }">
                  <el-button type="primary" size="small" @click="viewOrderDetail(row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-model:current-page="currentPage"
              v-model:page-size="pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              style="margin-top: 20px;"
            />
          </div>
        </div>

        <!-- 编辑邀请码模态框 -->
        <el-dialog
          title="编辑邀请码"
          v-model="editModalVisible"
          width="30%"
          @close="handleCloseModal"
        >
          <el-form
            :model="editForm"
            :rules="editRules"
            ref="editFormRef"
            label-width="120px"
          >
            <el-form-item label="有效天数" prop="validDays">
              <el-input-number
                v-model="editForm.validDays"
                :min="1"
                :disabled="editForm.permanent"
                placeholder="请输入有效天数"
              />
            </el-form-item>
            <el-form-item label="永久有效">
              <el-checkbox v-model="editForm.permanent" @change="togglePermanent" />
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="editForm.remark" placeholder="请输入备注，如测试或正式" />
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button @click="handleCloseModal">取消</el-button>
            <el-button type="primary" @click="updateInviteCode" :loading="editLoading">保存</el-button>
          </template>
        </el-dialog>

        <!-- 编辑用户信息模态框 -->
        <el-dialog
          title="编辑用户信息"
          v-model="userEditVisible"
          width="30%"
          @close="handleCloseUserEditModal"
        >
          <el-form
            :model="editUserForm"
            :rules="userEditRules"
            ref="userEditFormRef"
            label-width="120px"
          >
            <el-form-item label="用户名" prop="username">
              <el-input v-model="editUserForm.username" disabled />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="editUserForm.email" placeholder="请输入邮箱" />
            </el-form-item>
            <el-form-item label="版本" prop="version">
              <el-select v-model="editUserForm.version" placeholder="请选择版本">
                <el-option label="高级版" value="basic" />
                <el-option label="订阅版" value="advanced" />
                <el-option label="年费版" value="enterprise" />
              </el-select>
            </el-form-item>
            <el-form-item label="版本有效期" prop="versionPeriod">
              <el-select v-model="editUserForm.versionPeriod" placeholder="请选择有效期">
                <el-option label="周" value="week" />
                <el-option label="月" value="month" />
                <el-option label="季" value="quarter" />
                <el-option label="年" value="year" />
              </el-select>
            </el-form-item>
            <el-form-item label="订阅状态" prop="subscription_status">
              <el-switch v-model="editUserForm.subscription_status" />
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button @click="handleCloseUserEditModal">取消</el-button>
            <el-button type="primary" @click="saveUserEdit" :loading="editUserLoading">保存</el-button>
          </template>
        </el-dialog>

        <!-- 重置密码模态框 -->
        <el-dialog
          :title="resetTargetType === 'user' ? '重置用户密码' : '重置管理员密码'"
          v-model="resetPwdVisible"
          width="30%"
          @close="handleCloseResetPwdModal"
        >
          <el-form
            :model="resetPwdForm"
            :rules="resetPwdRules"
            ref="resetPwdFormRef"
            label-width="120px"
          >
            <el-form-item label="新密码" prop="password">
              <el-input
                v-model="resetPwdForm.password"
                type="password"
                placeholder="请输入新密码"
                show-password
              />
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input
                v-model="resetPwdForm.confirmPassword"
                type="password"
                placeholder="请再次输入新密码"
                show-password
              />
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button @click="handleCloseResetPwdModal">取消</el-button>
            <el-button type="primary" @click="confirmResetPassword" :loading="resetPwdLoading">确认</el-button>
          </template>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import { debounce } from 'lodash';

const router = useRouter();
const currentMenu = ref('invite');

// 订单管理相关变量
const orderList = ref([]);
const orderLoading = ref(false);
const orderError = ref('');
const currentPage = ref(1);
const pageSize = ref(50);
const total = ref(0);

const fetchOrders = async () => {
  if (!checkAdminLogin()) return;
  orderLoading.value = true;
  orderError.value = '';
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(
      'https://a.410121.xyz/api/admin/orders',
      {
        params: {
          page: currentPage.value,
          per_page: pageSize.value
        },
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 30000  // 延长超时时间到30秒
      }
    );
    if (response.data.code === 200) {
      orderList.value = response.data.data.list;
      total.value = response.data.data.total_count;
    } else {
      throw new Error(response.data.message || '获取订单列表失败');
    }
  } catch (err) {
    // 处理超时错误
    if (err.code === 'ECONNABORTED') {
      orderError.value = '请求超时，请稍后重试';
    } else {
      orderError.value = err.response?.data?.message || err.message || '获取订单列表失败';
    }
    ElMessage.error(orderError.value);
  } finally {
    orderLoading.value = false;
  }
};

const handleSizeChange = (size) => {
  pageSize.value = size;
  currentPage.value = 1;
  fetchOrders();
};

const handleCurrentChange = (page) => {
  currentPage.value = page;
  fetchOrders();
};

const viewOrderDetail = (row) => {
  ElMessage.info(`订单详情：${JSON.stringify(row, null, 2)}`);
  // 可扩展为模态框显示详情
};

// 订单状态映射
const statusTextMap = {
  0: '待支付',  // 新增：待支付
  1: '已取消',  // 新增：已取消
  2: '已支付',  // 原有
  3: '已退款'   // 新增：已退款
};

// 邀请码管理相关
const validDays = ref(30);
const remark = ref('');
const inviteCode = ref('');
const loading = ref(false);
const error = ref('');
const inviteList = ref([]);
const listLoading = ref(false);
const listError = ref('');
const editModalVisible = ref(false);
const editLoading = ref(false);
const editForm = reactive({
  id: null,
  validDays: 30,
  permanent: false,
  remark: ''
});
const editRules = {
  validDays: [
    { required: true, message: '请输入有效天数', trigger: 'blur' }
  ],
  remark: [
    { max: 100, message: '备注最多100个字符', trigger: 'blur' }
  ]
};
const editFormRef = ref(null);

// 管理员管理相关
const adminForm = reactive({
  username: '',
  password: ''
});
const adminRules = {
  username: [
    { required: true, message: '请输入管理员用户名', trigger: 'blur' },
    { min: 3, max: 20, message: '用户名长度必须在3到20个字符之间', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
  ]
};
const createAdminLoading = ref(false);
const createAdminError = ref('');
const createAdminSuccess = ref(false);
const adminList = ref([]);
const createAdminFormRef = ref(null);

// 用户管理相关
const userSearch = ref('');
const userList = ref([]);
const updatingSubscription = ref({});
const userEditVisible = ref(false);
const editUserLoading = ref(false);
const editUserForm = reactive({
  id: null,
  username: '',
  email: '',
  version: 'basic',
  versionPeriod: 'month',
  subscription_status: false
});
const userEditRules = {
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    { type: 'email', message: '请输入有效的邮箱地址', trigger: ['blur', 'change'] }
  ],
  version: [
    { required: true, message: '请选择版本', trigger: 'change' }
  ],
  versionPeriod: [
    { required: true, message: '请选择有效期', trigger: 'change' }
  ]
};
const resetPwdVisible = ref(false);
const resetPwdLoading = ref(false);
const resetPwdForm = reactive({
  password: '',
  confirmPassword: ''
});
const resetPwdRules = {
  password: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请再次输入新密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== resetPwdForm.password) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }
  ]
};
const userEditFormRef = ref(null);
const resetPwdFormRef = ref(null);
const resetTargetType = ref('');
const resetTargetId = ref(null);

const filteredUserList = computed(() => {
  const keyword = userSearch.value.toLowerCase();
  return userList.value.filter(
    user => user.username.toLowerCase().includes(keyword) || user.email.toLowerCase().includes(keyword)
  );
});

const checkAdminLogin = () => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    ElMessage.error('管理员未登录，请先登录');
    router.push('/admin-login');
    return false;
  }
  return true;
};

const generateInviteCode = async () => {
  if (!checkAdminLogin()) return;
  loading.value = true;
  error.value = '';
  inviteCode.value = '';
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.post(
      'https://a.410121.xyz/api/generate-invite',
      { validDays: validDays.value, remark: remark.value },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 201) {
      inviteCode.value = response.data.data.inviteCode;
      ElMessage.success('邀请码生成成功');
      fetchInviteCodes();
    } else {
      throw new Error(response.data.message || '生成邀请码失败');
    }
  } catch (err) {
    // 处理超时错误
    if (err.code === 'ECONNABORTED') {
      error.value = '请求超时，请稍后重试';
    } else {
      error.value = err.response?.data?.message || err.message || '生成邀请码失败';
    }
    ElMessage.error(error.value);
  } finally {
    loading.value = false;
  }
};

const fetchInviteCodes = async () => {
  if (!checkAdminLogin()) return;
  listLoading.value = true;
  listError.value = '';
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(
      'https://a.410121.xyz/api/invite-codes',
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      inviteList.value = response.data.data.map(item => ({
        ...item,
        is_expired: item.expires_at && new Date(item.expires_at) < new Date()
      }));
    } else {
      throw new Error(response.data.message || '获取邀请码列表失败');
    }
  } catch (err) {
    // 处理超时错误
    if (err.code === 'ECONNABORTED') {
      listError.value = '请求超时，请稍后重试';
    } else {
      listError.value = err.response?.data?.message || err.message || '获取邀请码列表失败';
    }
    ElMessage.error(listError.value);
  } finally {
    listLoading.value = false;
  }
};

const showEditModal = (row) => {
  editForm.id = row.id;
  editForm.validDays = row.expires_at
    ? Math.ceil((new Date(row.expires_at) - new Date()) / (1000 * 60 * 60 * 24))
    : 30;
  editForm.permanent = !row.expires_at;
  editForm.remark = row.remark || '';
  editModalVisible.value = true;
};

const handleCloseModal = () => {
  editModalVisible.value = false;
  editForm.id = null;
  editForm.validDays = 30;
  editForm.permanent = false;
  editForm.remark = '';
  if (editFormRef.value) {
    editFormRef.value.resetFields();
  }
};

const togglePermanent = () => {
  if (editForm.permanent) {
    editForm.validDays = null;
  } else {
    editForm.validDays = 30;
  }
};

const updateInviteCode = async () => {
  if (!checkAdminLogin()) return;
  try {
    await editFormRef.value.validate();
    editLoading.value = true;
    const token = localStorage.getItem('adminToken');
    const response = await axios.put(
      `https://a.410121.xyz/api/invite-codes/${editForm.id}`,
      {
        validDays: editForm.permanent ? null : editForm.validDays,
        permanent: editForm.permanent,
        remark: editForm.remark
      },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('邀请码更新成功');
      fetchInviteCodes();
      handleCloseModal();
    } else {
      throw new Error(response.data.message || '更新邀请码失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '更新邀请码失败');
  } finally {
    editLoading.value = false;
  }
};

const disableInviteCode = async (row) => {
  if (!checkAdminLogin()) return;
  if (!confirm('确定要禁用此邀请码吗？')) return;
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.put(
      `https://a.410121.xyz/api/invite-codes/${row.id}/disable`,
      {},
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('禁用成功');
      fetchInviteCodes();
    } else {
      throw new Error(response.data.message || '禁用邀请码失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '禁用邀请码失败');
  }
};

const deleteInviteCode = async (row) => {
  if (!checkAdminLogin()) return;
  if (!confirm('确定要删除此邀请码吗？')) return;
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.delete(
      `https://a.410121.xyz/api/invite-codes/${row.id}`,
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('删除成功');
      fetchInviteCodes();
    } else {
      throw new Error(response.data.message || '删除邀请码失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '删除邀请码失败');
  }
};

const copyInviteCode = async (code) => {
  try {
    await navigator.clipboard.writeText(code);
    ElMessage.success('邀请码已复制到剪贴板');
  } catch (err) {
    fallbackCopy(code);
  }
};

const fallbackCopy = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand('copy');
    ElMessage.success('邀请码已复制到剪贴板');
  } catch (err) {
    ElMessage.error('复制失败，请手动复制');
  }
  document.body.removeChild(textArea);
};

// 创建管理员
const createAdmin = async () => {
  if (!checkAdminLogin()) return;
  try {
    await createAdminFormRef.value.validate();
    createAdminLoading.value = true;
    createAdminError.value = '';
    createAdminSuccess.value = false;
    const token = localStorage.getItem('adminToken');
    const response = await axios.post(
      'https://a.410121.xyz/api/admins',
      {
        username: adminForm.username,
        password: adminForm.password
      },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 201) {
      ElMessage.success('管理员创建成功');
      createAdminSuccess.value = true;
      createAdminFormRef.value.resetFields();
      fetchAdmins();
    } else {
      throw new Error(response.data.message || '创建管理员失败');
    }
  } catch (err) {
    createAdminError.value = err.response?.data?.message || err.message || '创建管理员失败';
    ElMessage.error(createAdminError.value);
  } finally {
    createAdminLoading.value = false;
  }
};

const fetchAdmins = async () => {
  if (!checkAdminLogin()) return;
  listLoading.value = true;
  listError.value = '';
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(
      'https://a.410121.xyz/api/admins',
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      adminList.value = response.data.data;
    } else {
      throw new Error(response.data.message || '获取管理员列表失败');
    }
  } catch (err) {
    // 处理超时错误
    if (err.code === 'ECONNABORTED') {
      listError.value = '请求超时，请稍后重试';
    } else {
      listError.value = err.response?.data?.message || err.message || '获取管理员列表失败';
    }
    ElMessage.error(listError.value);
  } finally {
    listLoading.value = false;
  }
};

const fetchUsers = async () => {
  if (!checkAdminLogin()) return;
  listLoading.value = true;
  listError.value = '';
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(
      'https://a.410121.xyz/api/users',
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      userList.value = response.data.data.map(user => ({
        ...user,
        subscription_status: !!user.subscription_status,
        versionPeriod: user.version_expiry ? estimatePeriod(user.version_expiry) : 'month'
      }));
    } else {
      throw new Error(response.data.message || '获取用户列表失败');
    }
  } catch (err) {
    // 处理超时错误
    if (err.code === 'ECONNABORTED') {
      listError.value = '请求超时，请稍后重试';
    } else {
      listError.value = err.response?.data?.message || err.message || '获取用户列表失败';
    }
    ElMessage.error(listError.value);
  } finally {
    listLoading.value = false;
  }
};

// 计算版本有效期
const calculateExpiry = (period) => {
  const now = new Date();
  switch (period) {
    case 'week':
      return new Date(now.setDate(now.getDate() + 7)).toISOString();
    case 'month':
      return new Date(now.setDate(now.getDate() + 30)).toISOString();
    case 'quarter':
      return new Date(now.setDate(now.getDate() + 90)).toISOString();
    case 'year':
      return new Date(now.setDate(now.getDate() + 365)).toISOString();
    default:
      return null;
  }
};

// 估算时间段（反向推导）
const estimatePeriod = (expiry) => {
  if (!expiry) return 'month';
  const diffDays = Math.ceil((new Date(expiry) - new Date()) / (1000 * 60 * 60 * 24));
  if (diffDays <= 7) return 'week';
  if (diffDays <= 30) return 'month';
  if (diffDays <= 90) return 'quarter';
  return 'year';
};

const debouncedUpdateVersion = debounce(async (row, period) => {
  if (!checkAdminLogin()) return;
  try {
    const token = localStorage.getItem('adminToken');
    const version_expiry = period ? calculateExpiry(period) : null;
    const response = await axios.put(
      `https://a.410121.xyz/api/users/${row.id}/version`,
      { version: row.version, version_expiry },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('用户版本更新成功');
      await fetchUsers();
    } else {
      throw new Error(response.data.message || '更新用户版本失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '更新用户版本失败');
    await fetchUsers();
  }
}, 500);

const debouncedUpdateSubscription = debounce(async (row) => {
  if (!checkAdminLogin()) return;
  if (updatingSubscription.value[row.id]) return;
  updatingSubscription.value[row.id] = true;
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.put(
      `https://a.410121.xyz/api/users/${row.id}/subscription`,
      { subscription_status: row.subscription_status },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('订阅状态更新成功');
      await fetchUsers();
    } else {
      throw new Error(response.data.message || '更新订阅状态失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '更新订阅状态失败');
    await fetchUsers();
  } finally {
    updatingSubscription.value[row.id] = false;
  }
}, 500);

const showEditUserModal = (row) => {
  const user = userList.value.find(u => u.id === row.id);
  if (user) {
    editUserForm.id = user.id;
    editUserForm.username = user.username;
    editUserForm.email = user.email;
    editUserForm.version = user.version || 'basic';
    editUserForm.versionPeriod = user.versionPeriod || 'month';
    editUserForm.subscription_status = !!user.subscription_status;
    userEditVisible.value = true;
  } else {
    ElMessage.error('用户数据未找到');
  }
};

const handleCloseUserEditModal = () => {
  userEditVisible.value = false;
  editUserForm.id = null;
  editUserForm.username = '';
  editUserForm.email = '';
  editUserForm.version = 'basic';
  editUserForm.versionPeriod = 'month';
  editUserForm.subscription_status = false;
  if (userEditFormRef.value) {
    userEditFormRef.value.resetFields();
  }
};

const saveUserEdit = async () => {
  if (!checkAdminLogin()) return;
  try {
    await userEditFormRef.value.validate();
    editUserLoading.value = true;
    const token = localStorage.getItem('adminToken');
    const version_expiry = calculateExpiry(editUserForm.versionPeriod);
    const response = await axios.put(
      `https://a.410121.xyz/api/users/${editUserForm.id}`,
      {
        email: editUserForm.email,
        version: editUserForm.version,
        version_expiry,
        subscription_status: editUserForm.subscription_status
      },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('用户信息更新成功');
      fetchUsers();
      handleCloseUserEditModal();
    } else {
      throw new Error(response.data.message || '更新用户信息失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '更新用户信息失败');
  } finally {
    editUserLoading.value = false;
  }
};

const showResetPwdModal = (row, type) => {
  resetTargetType.value = type;
  resetTargetId.value = row.id;
  resetPwdForm.password = '';
  resetPwdForm.confirmPassword = '';
  resetPwdVisible.value = true;
};

const handleCloseResetPwdModal = () => {
  resetPwdVisible.value = false;
  resetTargetType.value = '';
  resetTargetId.value = null;
  if (resetPwdFormRef.value) {
    resetPwdFormRef.value.resetFields();
  }
};

const confirmResetPassword = async () => {
  if (!checkAdminLogin()) return;
  try {
    await resetPwdFormRef.value.validate();
    resetPwdLoading.value = true;
    const token = localStorage.getItem('adminToken');
    const url = resetTargetType.value === 'user'
      ? `https://a.410121.xyz/api/users/${resetTargetId.value}/password`
      : `https://a.410121.xyz/api/admins/${resetTargetId.value}/password`;
    const response = await axios.put(
      url,
      { password: resetPwdForm.password },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('密码重置成功');
      handleCloseResetPwdModal();
      if (resetTargetType.value === 'user') {
        fetchUsers();
      } else {
        fetchAdmins();
      }
    } else {
      throw new Error(response.data.message || '密码重置失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '密码重置失败');
  } finally {
    resetPwdLoading.value = false;
  }
};

const deleteAdmin = async (admin) => {
  if (!checkAdminLogin()) return;
  if (!confirm('确定要删除此管理员吗？')) return;
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.delete(
      `https://a.410121.xyz/api/admins/${admin.id}`,
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000  // 延长超时时间
      }
    );
    if (response.data.code === 200) {
      ElMessage.success('管理员删除成功');
      fetchAdmins();
    } else {
      throw new Error(response.data.message || '删除管理员失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '删除管理员失败');
  }
};

// 切换用户封禁状态
const toggleUserBan = async (row) => {
  if (!checkAdminLogin()) return;
  const action = row.is_banned ? '解封' : '封禁';
  if (!confirm(`确定要${action}此用户吗？`)) return;
  
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.put(
      `https://a.410121.xyz/api/users/${row.id}/ban`,
      { is_banned: !row.is_banned },
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000
      }
    );
    
    if (response.data.code === 200) {
      ElMessage.success(`${action}成功`);
      fetchUsers();
    } else {
      throw new Error(response.data.message || `${action}失败`);
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || `${action}失败`);
  }
};

// 格式化日期
const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

onMounted(() => {
  if (checkAdminLogin()) {
    fetchInviteCodes();
    fetchAdmins();
    fetchUsers();
  }
});

watch(currentMenu, (newVal) => {
  if (newVal === 'order') {
    fetchOrders();
  }
});
</script>

<style scoped>
.management-menu {
  max-width: 1000px;
  margin-left: 30%;
  margin-bottom: 20px;
  padding: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.active-menu {
  background-color: #409eff; 
  color: white;
}

.generate-container {
  width: 97%;
  margin-left: 200px;
  padding: 22px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

/* 新增：其他管理模块占位样式 */
.management-placeholder {
  padding: 50px;
  color: #666;
  font-size: 18px;
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

button {
  padding: 10px 20px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 10px;
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.success p {
  font-size: 18px;
  margin-bottom: 10px;
}

.error {
  color: red;
  margin-bottom: 10px;
}

.loading {
  font-size: 16px;
  color: #007bff;
}
</style>